<div class="pricingDailog">
  <div>
    <div>
      <form [ngClass]="" style="background: #f8f9fa;" (ngSubmit)="confirmPayment($event)">
        <div class="row me-0 ms-0" style="padding-top: 15px;">
          <div class="col-md-12" style="height: 600px;overflow: auto;">
            <div class="form-group pt-1"
              style=" background: black; text-align: center; line-height: 39px; border-radius: 4px;margin-top: 13px;">
              <app-g-pay [final_amount]="'100'" (confirmPayment)="confirmPayment($event)">
              </app-g-pay>
            </div>
            <!-- wallets option -->
            <div id="payment_request_button"></div>
            <!-- <div style="font-weight: 600;font-size: 17px;margin-top: 20px;"><label>Link Authentication</label></div> -->
            <!-- <div id="link-authentication-element"></div> -->
            <div style="font-weight: 600;font-size: 17px;margin-top: 20px;"><label>Billing details</label></div>
            <div id="address-element"></div>
            <!-- card stripe option -->
            <div style="font-weight: 600;font-size: 17px;margin-top: 20px;"><label>Payment Method</label></div>
            <div style="border: none;padding: 0;" class="-stripe-card" id="add_card"></div>
          </div>
        </div>
      </form>
      <div>
        <button (click)="confirmPayment($event)" style="    width: 100%;
        height: 50px;
        background: #00799c;
        border: none;
        color: white;
        font-size: 20px;
        font-weight: bold;">
        <span *ngIf="obj.trial_period">Add</span>
        <span *ngIf="!obj.trial_period">Pay <span class="ms-3"> {{obj.display_logo}} </span> <span class="ms-1">{{amount}}</span> </span></button>
      </div>
    </div>
  </div>
</div>